/* eslint-disable no-inline-comments */
// @flow
import imported from 'react-imported-component';
import { thenFunction } from '../../utils/imported';

export const Box = imported(() => import(/* webpackChunkName: "components-Box" */ './Box').catch(() => thenFunction()));
